<template>
  <vs-row>
    <vs-col class="w-full xl:w-9/12">
      <vx-card>
        <div>
          <heading style-size="h4" size="h1" class="mb-2">
            Your Work Experience Certificates
          </heading>
          <p class="my-5">
            You can now request your Work Experience Certificate by clicking on the red “Request
            Certificate” button below.
          </p>
          <p class="my-5">
            Once your teacher has checked what you have completed for Work Experience, they will
            issue your certificate and it will appear below.
          </p>
          <p class="my-5">
            You can download it, print it, and even use it to add to your career portfolio.
          </p>
        </div>
      </vx-card>

      <heading style-size="h4" size="h2" class="my-5">Approved Certificates</heading>
      <certificate-table
        :data="data[2]"
        no-data-text="No Certificates Approved"
      ></certificate-table>

      <heading style-size="h4" size="h2" class="my-5">Declined Certificates</heading>
      <certificate-table
        :data="data[3]"
        no-data-text="No Certificates Declined"
      ></certificate-table>

      <heading style-size="h4" size="h2" class="my-5">Requested Certificates</heading>
      <certificate-table
        :data="data[1]"
        no-data-text="No Certificates Requested"
      ></certificate-table>

      <heading style-size="h4" size="h2" class="my-5">Not Requested Certificates</heading>
      <certificate-table
        :data="data[0]"
        no-data-text="No Certificates to Request"
      ></certificate-table>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" class="w-full xl:w-3/12 pt-10 xl:pl-10 xl:pt-0">
      <vx-card>
        <h4 class="mb-5">Tips & Tricks</h4>
        <p class="mb-5">"The only place where success comes before work is in the dictionary.”</p>
        <p>(Vince Lombardi)</p>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { successToast, errorToast } from '@/utils/toast';
import themeConfig from '@/../themeConfig';
import CertificateTable from '@/components/UI/students/CertificateTable';
import theApi from '@/mixins/theApi';
import store from '@/store/store';
import router from '@/router/router';
export default {
  components: { CertificateTable },
  computed: {
    settings() {
      return store.getters['authStudent/settings'];
    },
    experiences() {
      return store.getters['authStudent/experiences'];
    },
  },
  data() {
    return {
      contentWidth: themeConfig.contentWidth,
      sidebarWidth: themeConfig.sidebarWidth,
      data: {
        0: [],
        1: [],
        2: [],
        3: [],
      },
    };
  },
  methods: {
    async requestCertificate(vje_id) {
      const formData = new FormData();
      formData.append('vje_id', vje_id);

      //Disable the Request button
      store.commit('authStudent/setIsRequestedCertificate', {
        id: vje_id,
        is_certificate_requested: true,
      });
      theApi.methods.makeCall(false, 'certificate/request', 'post', formData, null, true).then(
        (data) => {
          if (data.status == 'OK') {
            //Remove experience from 'Not Requested' and move it to 'Requested' certificates group
            const certificate_data = {
              id: vje_id,
              postwork: data.postwork,
              data: data.data,
            };
            store.commit('authStudent/requestedCertificate', certificate_data);
            this.getCertificates();
            //Show success message
            this.$toast.success('Certificate requested successfully.', successToast());

            //this.data = data.data;
          }
        },
        () => {
          store.commit('authStudent/setIsRequestedCertificate', {
            id: vje_id,
            is_certificate_requested: false,
          });
        },
      );
    },
    async getCertificates() {
      this.data[0] = [];
      this.data[1] = [];
      this.data[2] = [];
      this.data[3] = [];
      const experiences = Array.from(this.experiences);
      experiences.forEach((experience) => {
        if (experience.completed) {
          if (experience.postwork) {
            this.data[experience.postwork.certificate_status].push(experience.certificate_data);
          } else if (experience.id) this.data[0].push(experience.certificate_data);
        }
        const makeDate = (str) => {
          /* eslint-disable no-unused-vars */

          const [_, dd, mm, yyyy, hh, min] = str.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
          return new Date(yyyy, mm - 1, dd, hh, min, 0);
        };
        for (let i = 0; i <= 3; i++) {
          if (this.data[i].length > 0)
            this.data[i].sort((a, b) => makeDate(b.date) - makeDate(a.date));
        }
      });
    },
    getStatusColor(status) {
      if (status == 0) return 'dark';
      else if (status == 1) return 'danger';
      else if (status == 2) return 'success';
      else if (status == 3) return 'dark';
    },
  },
  mounted() {
    if (
      typeof this.settings['certificates'] !== 'undefined' &&
      this.settings['certificates'] == false
    ) {
      router.push('/student/dashboard');
    } else {
      this.getCertificates();
    }
  },
  provide: function () {
    return {
      requestCertificate: this.requestCertificate,
    };
  },
  watch: {
    experiences() {
      this.getCertificates();
    },
  },
};
</script>
